import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Consultant } from 'src/app/models/consultant.model';
import { fromConsultant } from 'src/app/reducers/consultant.reducer';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'ct-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public consultant$: Observable<Consultant>;

  constructor(
    public authenticationService: AuthenticationService,
    private store: Store,
    public router: Router
  ) { }

  ngOnInit(): void {
    this.consultant$ = this.store.pipe(select(fromConsultant.selectConsultantState));
    if (this.consultant$) {
      this.router.navigate(['consultant/candidates']);
    }

    this.authenticationService.signInWithCrossStorage();

    // Si no tenemos sesión, iniciamos login de Google.
    this.authenticationService.signinWithGoogle();

  }

}
